import axios from './request'

const URL = {
  entrust: {
    list: '/MATCH-FACADE-SERVER/entrust/query.magpie', // 查询委托单列表
    detail: '/MATCH-FACADE-SERVER/entrust/detail.magpie', // 查询委托单详情
    cancel: '/MATCH-FACADE-SERVER/entrust/remove.magpie', // 撤销委托
  },
  trading: {
    list: '/MATCH-FACADE-SERVER/trading/query.magpie', // 查询成交单列表
    detail: '/MATCH-FACADE-SERVER/trading/detail.magpie', // 查询成交单详情
  },
  total: {
    list: '/MATCH-FACADE-SERVER/trading/queryOrder.magpie', // 查询总订单列表
    detail: '/MATCH-FACADE-SERVER/trading/orderDetail.magpie', // 查询总订单详情
  }
}

// 我的账户
class TransationManage {
  // 查询委托单列表
  entrustList (params) {
    const url = URL.entrust.list
    return axios.post(url, params)
  }
  // 查询委托单详情
  entrustDetail (params) {
    const url = URL.entrust.detail
    return axios.post(url, params)
  }
  // 撤销委托单
  entrustCancel (params) {
    const url = URL.entrust.cancel
    return axios.post(url, params)
  }
  // 查询成交单列表
  tradingList (params) {
    const url = URL.trading.list
    return axios.post(url, params)
  }
  //  查询成交单详情
  tradingDetail (params) {
    const url = URL.trading.detail
    return axios.post(url, params)
  }
  // 查询总订单列表
  totalList (params) {
    const url = URL.total.list
    return axios.post(url, params)
  }
  //  查询总订单详情
  totalDetail (params) {
    const url = URL.total.detail
    return axios.post(url, params)
  }
}

export default new TransationManage()
